import { render, staticRenderFns } from "./AccountActivity.vue?vue&type=template&id=8e81b318&"
import script from "./AccountActivity.vue?vue&type=script&lang=js&"
export * from "./AccountActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports